import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { Badge } from '@material-ui/core';
import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { CheckList } from '../../../icons';
import { getCurrentCheckLists } from '../../../selectors/checkList';
import { useStyles } from './useStyles';

export const CheckListAdapter = memo(({ value, selected, onClick, className }) => {
    const { isCheckList, isCheckListComplited } = useSelector(() => {
        const currentCheckLists = useSelector(getCurrentCheckLists);
        const isCheckList = Boolean(currentCheckLists);
        const isCheckListComplited =
            isCheckList &&
            Object.keys(currentCheckLists).reduce((res, key) => {
                if (!currentCheckLists[key].completed) {
                    res = false;
                }

                return res;
            }, true);

        return {
            isCheckList,
            isCheckListComplited,
        };
    }, shallowEqual);

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    return isCheckList ? (
        <ListItem onClick={handleClick} button={true} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Badge color="secondary" variant="dot" invisible={isCheckListComplited}>
                    <CheckList width="24" height="24" className={classes.checkListIcon} />
                </Badge>
            </ListItemIcon>
            <ListItemText primary={translate('labels.checkList')} className={className} />
        </ListItem>
    ) : (
        ''
    );
});

CheckListAdapter.displayName = 'CheckListAdapter';
